module.exports = {
	"1": {
		"provisions": {
			"provision 1.3": true,
			"provision 1.1": true,
			"provision 1.4": true,
			"provision 1.2": true
		},
		"max": 400
	},
	"2": {
		"provisions": {
			"provision 2.1": true,
			"provision 2.2": true
		},
		"max": 200
	},
	"3": {
		"provisions": {
			"provision 3": true
		},
		"max": 100
	},
	"4": {
		"provisions": {
			"provision 4": true
		},
		"max": 100
	},
	"5": {
		"provisions": {
			"provision 5.2": true,
			"provision 5.1": true,
			"provision 5.3": true
		},
		"max": 300
	},
	"6": {
		"provisions": {
			"provision 6.1": true,
			"provision 6.3": true,
			"provision 6.2": true
		},
		"max": 300
	},
	"7": {
		"provisions": {
			"provision 7.2": true,
			"provision 7.6": true,
			"provision 7.1": true,
			"provision 7.9": true,
			"provision 7.5": true,
			"provision 7.3": true,
			"provision 7.7": true,
			"provision 7.8": true,
			"provision 7.4": true
		},
		"max": 900
	},
	"8": {
		"provisions": {
			"provision 8": true
		},
		"max": 100
	},
	"9": {
		"provisions": {
			"provision 9": true
		},
		"max": 100
	},
	"10": {
		"provisions": {
			"provision 10.4": true,
			"provision 10.1": true,
			"provision 10.7": true,
			"provision 10.9": true,
			"provision 10.2": true,
			"provision 10.8": true,
			"provision 10.5": true,
			"provision 10.6": true,
			"provision 10.3": true
		},
		"max": 900
	},
	"11": {
		"provisions": {
			"provision 11": true
		},
		"max": 100
	},
	"12": {
		"provisions": {
			"provision 12": true
		},
		"max": 100
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/data_tfa_articles_meta.json
// module id = 590
// module chunks = 0